const actions = {
	GET_SUMMARIZE_SPOKEN_TEXT: 'GET_SUMMARIZE_SPOKEN_TEXT',
	GET_SUMMARIZE_SPOKEN_TEXT_SUCCESS: 'GET_SUMMARIZE_SPOKEN_TEXT_SUCCESS',

	CREATE_NEW_QUESTION_SUMMARIZE_SPOKEN_TEXT: 'CREATE_NEW_QUESTION_SUMMARIZE_SPOKEN_TEXT',
	CREATE_NEW_QUESTION_SUMMARIZE_SPOKEN_TEXT_SUCCESS: 'CREATE_NEW_QUESTION_SUMMARIZE_SPOKEN_TEXT_SUCCESS',

	DELETE_SUMMARIZE_SPOKEN_TEXT: 'DELETE_SUMMARIZE_SPOKEN_TEXT',
	DELETE_SUMMARIZE_SPOKEN_TEXT_SUCCESS: 'DELETE_SUMMARIZE_SPOKEN_TEXT_SUCCESS',

	GET_SUMMARIZE_SPOKEN_TEXT_DETAIL: 'GET_SUMMARIZE_SPOKEN_TEXT_DETAIL',
	GET_SUMMARIZE_SPOKEN_TEXT_DETAIL_SUCCESS: 'GET_SUMMARIZE_SPOKEN_TEXT_DETAIL_SUCCESS',

	UPDATE_SUMMARIZE_SPOKEN_TEXT_DETAIL: 'UPDATE_SUMMARIZE_SPOKEN_TEXT_DETAIL',
	UPDATE_SUMMARIZE_SPOKEN_TEXT_DETAIL_SUCCESS: 'UPDATE_SUMMARIZE_SPOKEN_TEXT_DETAIL_SUCCESS',

	LISTENING_LOADING_FALSE: 'LISTENING_LOADING_FALSE',
	//#region CRUD

	getSummarizeSpokenText: (model) => ({
		type: actions.GET_SUMMARIZE_SPOKEN_TEXT,
		payload: { model },
	}),

	createQuesSummarizeSpokenText: (model, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_SUMMARIZE_SPOKEN_TEXT,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	getSummarizeSpokenTextDetail: (id) => ({
		type: actions.GET_SUMMARIZE_SPOKEN_TEXT_DETAIL,
		payload: { id },
	}),

	updateSummarizeSpokenTextDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_SUMMARIZE_SPOKEN_TEXT_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteSummarizeSpokenText: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_SUMMARIZE_SPOKEN_TEXT,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
